export const columns = [
  {
    title: "Descripción",
    dataIndex: "descripcion",
  },
  {
    title: "Cantidad",
    dataIndex: "cantidad",
  },
  {
    title: "Objeto",
    dataIndex: "objeto",
  },
];

export const formatData = (data) => {
  return {
    idRequerimientoEvolucion: data.id,
    reevo_descripcion: data.descripcion,
    reevo_cantidad: data.cantidad,
    obje_id: data.idObjeto,
  };
};

export const camposFormulario = (objetos = []) => {
  return {
    title: "Requerimiento de Evolución",
    campos: [
      {
        name: "idRequerimientoEvolucion",
        label: "id",
        type: "number",
        hidden: true,
      },
      {
        name: "obje_id",
        label: "Objeto",
        type: "autocomplete",
        opciones: objetos,
        rules: [
          {
            required: true,
            message: "Seleccione un objeto",
          },
        ],
      },
      {
        name: "reevo_cantidad",
        label: "Cantidad",
        type: "number",
        max: 10,
        min: 1,
        rules: [
          {
            required: true,
            message: "Por favor ingrese una cantidad",
          },
        ],
      },
      {
        name: "reevo_descripcion",
        label: "Descripción",
        type: "text",
        rules: [
          {
            required: true,
            message: "Ingrese una descripción para este requerimiento",
          },
        ],
      },
    ],
  };
};
export const camposFilter = {
  title: "Requerimiento de Evolución",
  campos: [
    {
      name: "descripcion",
      type: "text",
      placeholder: "Descripción",
      rules: [
        {
          max: 45,
        },
      ],
    },
  ],
};
